var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',{ref:"drawing"},_vm._l((_vm.shapeConfigs),function(shapes,drawer){return _c('v-group',{key:drawer,attrs:{"id":drawer}},_vm._l((shapes),function(shape){return _c('v-line',{key:shape.id,attrs:{"config":shape}})}),1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }